import { IReport6Report } from "../../../model/report/Report6Report";
import { DateService } from "../../../service/DateService";
import Report6RiskCriteriaPresentationModel, {
  TReport6RiskCriteriaPresentationModel
} from "./Report6RiskCriteriaPresentationModel";
import { IReport6RiskCriteria } from "../../../model/report/Report6RiskCriteria";

export interface TReport6ReportPresentationModel {
  id: number;
  version: number;
  submitReason: string;
  submitDate: string;
  regularEvaluationStatus: string;
  regularEvaluationDate: string;
  reportingPeriodId: number;
  formalEvaluationStatus: string;
  formalEvaluationDate: string;
  financialImbalance: boolean;
  applicantReportingPeriodId: number;
  reportTypeCode: string;
  reportTypeName: string;
  riskCriterias: TReport6RiskCriteriaPresentationModel[];
}

const Report6ReportPresentationModel = (
  data: IReport6Report
): TReport6ReportPresentationModel => {
  const submitDate = data.submitDate
    ? DateService().formatDate(data.submitDate)
    : "";
  const regularEvaluationDate = data.regularEvaluationDate
    ? DateService().formatDate(data.regularEvaluationDate)
    : "";
  const formalEvaluationDate = data.formalEvaluationDate
    ? DateService().formatDate(data.formalEvaluationDate)
    : "";
  return {
    ...data,
    submitDate,
    regularEvaluationDate,
    formalEvaluationDate,
    riskCriterias: data.riskCriterias.map(
      (riskCriteria: IReport6RiskCriteria) => {
        return Report6RiskCriteriaPresentationModel(riskCriteria);
      }
    )
  };
};

export default Report6ReportPresentationModel;
